'use client';

import {useContext} from 'react';
import styled from '@emotion/styled';

import theme from 'theme';

import {Label, FieldComponent as BaseFieldComponent, inputStyle as baseGetInputStyle} from 'Input';
import {SelectContext} from 'Select/Select';

import {Chips} from './Chips';

import type {InputInputComponent, InputStyles} from 'Input';

const Container = styled.div`
  position: relative;
  flex-grow: 1;
  height: 100%;

  input:read-only {
    cursor: default;
  }
`;

const getInputStyle = (style: InputStyles) => {
  return baseGetInputStyle(style, {
    padding: style.isFilled && style.isLabeled && !style.isSmall ? '20px 0 4px' : 0,
  });
};

const FieldComponent = styled(BaseFieldComponent)`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
`;

const InputComponent = styled.input`
  width: 0;
  min-width: 30px;
  margin: 0;
  padding: 0;
  flex-grow: 1;
  border: none;
  outline: none;
  background-color: transparent;
  cursor: ${props => (props.readOnly ? 'default' : undefined)};

  ${theme.typography.p1}
`;

export const InputChips: InputInputComponent = props => {
  const isReadOnly = !useContext(SelectContext).filter;

  const componentProps = {
    isReadOnly,

    style: getInputStyle(props.style),
  };

  const inputProps = {
    ...props.inputProps,

    readOnly: isReadOnly,

    'data-qa': props.qa,
  };

  return (
    <Container>
      <Label {...props} />
      <FieldComponent as="div" {...componentProps} autoComplete="off">
        <Chips />
        <InputComponent {...inputProps} autoComplete="off" />
      </FieldComponent>
    </Container>
  );
};
